import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
// locals
// Style
import './App.css';
// Components
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import NotFound from './components/NotFound'
// Pages (lazy-loaded to defer large bundles until needed)
const Home = lazy(() => import('./pages/Home'));
const BlogCase = lazy(() => import('./pages/Projects/BlogCase'));
const AudioBookCase = lazy(() => import('./pages/Projects/AudioBookCase'));
const DiscordBotCase = lazy(() => import('./pages/Projects/DiscordBotCase'));
const TicTacToeCase = lazy(() => import('./pages/Projects/TicTacToeCase'));
const KnightlyConquestCase = lazy(() => import('./pages/Projects/KnightlyConquestCase'));
const Resume = lazy(() => import('./pages/Resume'));

function App() {
  return (
    <div className="App bg-slate-950">
      <Navbar />

      {/* Content */}
      <Suspense fallback={<div className="h-screen" />}>
      <Routes>
        {/* Home */}
        <Route path='/' element={<Home />} />
        {/* Resume */}
        <Route path='/resume' element={<Resume />} />
        {/* Case Studies */}
        <Route path='/projects/tic-tac-toe' element={<TicTacToeCase />} />
        <Route path='/projects/blogwebapp' element={<BlogCase />} />
        <Route path='/projects/discordbot' element={<DiscordBotCase />} />
        <Route path='/projects/audiobookapp' element={<AudioBookCase />} />
        <Route path='/projects/knightly-conquest' element={<KnightlyConquestCase />} />
        {/* ErrorHandler */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      </Suspense>

      <Footer />
    </div>
  );
}

export default App;
